import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import ServiceForm from './form';
import ServiceService from '../../services/service-service';
import { isRequired } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const service = ServiceService;

  const getErrors = values => {
    const errors = {};
    const minimumValues = {
      code: values.code,
      name: values.name,
      riskIndicator: values.riskIndicator ? values.riskIndicator.value : ''
    };
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);
    return errors;
  };

  const wrapperInformation = newValues => {
    const finalValues = {
      ...newValues,
      riskIndicator: newValues.riskIndicator.value
    };
    return finalValues;
  };

  const initialWrapperData = values => {
    const newValues = {
      ...values,
      riskIndicator: { name: values.riskIndicator, value: values.riskIndicator }
    };

    return newValues;
  };
  return {
    getErrors,
    service,
    wrapperInformation,
    initialWrapperData,
    keyName: 'code'
  };
};

export default withStyles(styles)(EditForm(Edit)(ServiceForm));
